import { toast } from 'react-toastify';

export const checkReadingLimit = async (userId, component, retrySupabaseQuery, supabase) => {
    const { count, error } = await retrySupabaseQuery(() =>
        supabase
            .schema('public')
            .from('card_readings')
            .select('*', { count: 'exact' })
            .eq('user_id', userId)
            .eq('component', component)
    );
    if (error) throw error;
    return count < 10;
};

export const handleDeleteReading = async (readingId, fetchSavedReadings, retrySupabaseQuery, supabase) => {
    console.log('Attempting to delete reading with ID:', readingId);
    try {
        const { error } = await retrySupabaseQuery(() =>
            supabase
                .schema('public')
                .from('card_readings')
                .delete()
                .eq('id', readingId)
        );

        if (error) {
            console.error('Delete error:', error);
            throw error;
        }

        toast.success('Reading deleted successfully!');
        await fetchSavedReadings();
    } catch (err) {
        toast.error('Failed to delete reading.');
        console.error('Error deleting reading:', err.message);
    }
};
